import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@mui/material';
import type { Liga } from '../../types/liga';

export interface ConfirmDeleteLeagueDialogProps {
  open: boolean;
  league: Liga | null;
  onCancel: () => void;
  onConfirm: (id: string) => Promise<void>;
}

const ConfirmDeleteLeagueDialog: React.FC<ConfirmDeleteLeagueDialogProps> = ({
  open,
  league,
  onCancel,
  onConfirm,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleConfirm = async () => {
    if (!league?.id) return;
    setLoading(true);
    setError(null);
    try {
      await onConfirm(league.id);
    } catch (err: any) {
      const msg = err?.message || 'Erro ao deletar liga.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel}>
      <DialogTitle>Deletar Liga</DialogTitle>
      <DialogContent dividers>
        <p>
          Tem certeza que deseja deletar a liga{' '}
          <strong>{league?.nome}</strong>? Esta ação não pode ser desfeita.
        </p>
        {error && (
          <div className="text-danger small">
            {error}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={loading}
        >
          {loading ? 'Deletando...' : 'Deletar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteLeagueDialog;







